import React from "react";
import { Button, classnames, Icon } from "@culturehq/components";
import { Template } from "chq";

import { Trans } from "app/utils";
import ChqModalConfirm from "components/common/ChqModalConfirm";

interface CardProps {
  template: Template;
  isSelectedTemplate?: boolean;
  onSelectedTemplate: (template: Template) => void;
  onTrigger: () => void;
  templateLibrary?: boolean;
}

const Card: React.FC<CardProps> = ({
  template,
  isSelectedTemplate,
  onSelectedTemplate,
  onTrigger,
  templateLibrary
}) => (
  <div
    className={classnames("PhotoGroup__thumbnail", "Story", "Template")}
    onClick={onTrigger}
    role="button"
    style={{ backgroundImage: `url(${template.posterUrl})` }}
    tabIndex={0}
  >
    <div className="Story__information--profile">
      <div className="background-container">
        <div className="Story__creator">
          <div>
            <h4 className="Template-Title">{template.name}</h4>
            <p>{template.description}</p>
          </div>
        </div>
        {isSelectedTemplate && (
          <div className="footer">
            <Button className="chq-btn-iv">
              <Icon icon="checkmark" /><Trans>Selected</Trans>
            </Button>
          </div>
        )}
        <Icon className="play-icon" icon="play-no-border" />
      </div>
    </div>
    <div className="Story__information--profile Story__answer">
      <div className="background-container">
        <div className="footer">
          <ChqModalConfirm
            onAccept={(event?: React.MouseEvent<HTMLButtonElement>) => {
              if (event) event.stopPropagation();
              onSelectedTemplate(template);
            }}
            trigger={(onTrigger: () => void) => (
              <Button
                className={isSelectedTemplate ? "chq-btn-iv" : ""}
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  event.stopPropagation();
                  onTrigger();
                }}
              >
                {isSelectedTemplate ? (
                  <><Icon icon="checkmark" /><Trans>Selected</Trans></>
                ) : (
                  <><Icon icon="ios-plus" /><Trans>Select Template</Trans></>
                )}
              </Button>
            )}
          >
            {isSelectedTemplate ? (
              <Trans>
                Are you sure you want to delete this template?
                Any changes you made except for adjustments to the video(s) will be lost.
              </Trans>
            ) : (
              <Trans>
                Are you sure you want to select this template?
                {!templateLibrary && "Any changes you made except for adjustments to the video(s) will be lost."}
              </Trans>
            )}
          </ChqModalConfirm>
        </div>
      </div>
    </div>
  </div>
);

export default Card;
